import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { theme } from '@omnigenbiodata/ui';
import { ReactNode } from 'react';

const primaryTint = theme.palette.grey[100];

export interface PageBannerProps {
  title: string;
  description: string;
  extras?: ReactNode;
  status?: 'error' | 'success' | 'warning' | 'info';
}

function PageBanner({ title, description, extras, status }: PageBannerProps) {
  return (
    <Paper
      elevation={3}
      sx={{
        mb: 3,
        border: 1,
        borderColor: 'rgba(16, 53, 68, 0.18)',
        bgcolor: primaryTint,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ height: 8, bgcolor: status ? `${status}.main` : 'primary.main' }} />

      <Box p={{ xs: 2.5, md: 3.5 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={8}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                color: 'primary.main',
                mb: 1,
              }}
            >
              {title}
            </Typography>

            <Typography
              variant="body1"
              component="p"
              color="text.secondary"
              sx={{
                maxWidth: 760,
                lineHeight: 1.55,
              }}
            >
              {description}
            </Typography>
          </Grid>

          {extras && (
            <Grid item xs={12} md={4}>
              {extras}
            </Grid>
          )}
        </Grid>
      </Box>
    </Paper>
  );
}

export default PageBanner;
